<template>
  <div class="forgot-page">
    <v-container class="mt-4" fluid fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6">
          <v-card class="elevation-12">
            <v-toolbar dark v-bind:class="[isValis ? 'header-color-valis' : isCpmMode ? 'header-color-cpm-rakuten' : 'header-color']">
              <v-toolbar-title class="toolbar-title">{{ $t("forgot.title") }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              {{ $t("forgot.message") }}
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  prepend-icon="mdi-account" v-model="email"
                  :rules="emailRules"
                  :label="$t('forgot.form.email.label')"
                  required
                  variant="underlined"
                ></v-text-field>
                <v-alert v-if="error" :value="true" outlined color="error" type="error">
                  <span v-html="error"></span>
                </v-alert>
                <v-btn :disabled="!valid" @click="forgetButtonClick">{{$t("forgot.submit")}}</v-btn>
              </v-form>
              <div class="text-right">
                <router-link :to="'login'">{{$t("forgot.back")}}</router-link>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Forgot',
  data: function () {
    return {
      valid: true,
      email: '',
      emailRules: [
        (v) => !!v || this.$t('commons.validation.email.required'),
        (v) => /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) || this.$t('commons.validation.email.invalid')
      ],
      error: undefined,
      isValis: false,
      isCpmMode: false
    }
  },
  methods: {
    ...mapActions('auth', ['forget', 'setLoginError', 'setupdateEmail']),
    forgetButtonClick: function () {
      if (this.$refs.form.validate()) {
        this.error = null
        this.forget(this.email)
          .then((result) => {
            this.error = undefined
            this.setLoginError('')
            this.setupdateEmail(this.email)
            this.$router.replace('/rePassword')
          })
          .catch((err) => {
            switch (err.code) {
              case 'NotAuthorizedException':
                this.error = this.$t('commons.cognito.notAuthorized', [err.message])
                break
              case 'InvalidParameterException':
              case 'InvalidPasswordException':
                this.error = this.$t('commons.cognito.invalidParam', [err.message])
                break
              case 'UserNotFoundException':
                this.error = this.$t('commons.cognito.invalidMail', [err.message])
                break
              case 'LimitExceededException':
                this.error = this.$t('commons.cognito.limitExceeded', [err.message])
                break
              default:
                this.error = this.$t('commons.cognito.otherAuthError', [err.message])
                break
            }
          })
        this.setLoginError(this.error)
      }
    }
  },
  mounted: function () {
    var privateCode = process.env.ProjectCode
    if (privateCode === '301') {
      this.isValis = true
    } else if (privateCode === '111') {
      this.isCpmMode = true
    }
  }
}
</script>
<style scoped>
.header-color {
  background-color: #4b7001 !important;
}
.header-color-valis {
  background-color: #093493 !important;
}
.header-color-cpm-rakuten {
  background-color: #BF0000 !important;
}

.forgot-page {
  min-height: 100%;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
}

.toolbar-title {
  color: #FFFFFF !important;
}
</style>